import { __awaiter } from "tslib";
import Time from 'date-and-time';
import { Container, Service } from './container';
import { Api } from './api';
import { Config } from './config';
import { AppState } from '../etc/stores';
import { Checkout } from './checkout';
import { Backend } from './backend';
import { get } from 'svelte/store';
import { WidgetConnect } from './widget-connect';
import flagKeys from '../etc/flagKeys';
import { moneyToCoins } from '../etc/utils';
import { SessionManager } from './session-manager';
import sessionKeys from '../etc/sessionKeys';
const WIX_CONNECTING_ACCOUNT = 'wix_connecting_account';
const MOCKED_SITE_MEMBER = {
    member: {
        id: '60af6251-457a-4041-a253-dd4738f0c8ea'
    },
    signedToken: 'eyJraWQiOiIya0RibDk4aiIsImFsZyI6IlJTMjU2In0.eyJkYXRhIjp7IlNIQTI1NiI6IntcIm1lbWJlclwiOntcImlkXCI6XCI2MGFmNjI1MS00NTdhLTQwNDEtYTI1My1kZDQ3MzhmMGM4ZWFcIn19In0sImlhdCI6MTYxNTQ3OTk4MSwiZXhwIjoxNjUxNDc5OTgxfQ.j477iIu64icO4YjZNhRgan9tuTVG5x8R0UUL8djXTMSi6YZZnM54GRYctzAxfwyxSR88kZf-GpeadlDS2d10QSZR60jh8GZe0s7itMvvMtU1m6Ersi8bJ2T_vf2kV30pMudqxDSw7GULdPb9rAIHC2nj8RUkkzzE4fNGLIWRyX9GKtg6_ZSNjVKbv970K3GzQNTBBBWa3VmT5nxt0pzXFZmC513x7GGCIEX6NpMY64aXVS6dTfWeR4ttSIqV1T0a7RANPQIo3mq8F-ibXSj7LOemCUSjCZIelErh6dnRxHVGBbLNCPfkle763bYqxS_z0BDo6844n0ZwDRWXxQiIPQ'
};
export class Wix extends Service {
    constructor() {
        super(...arguments);
        this.config = this.ctx.get(Config);
        this.api = this.ctx.get(Api).create('');
        this.checkout = this.ctx.get(Checkout);
        this.session = this.ctx.get(SessionManager);
        this.connect = this.ctx.get(WidgetConnect);
        this.backend = this.ctx.get(Backend);
    }
    getCurrentMember() {
        return __awaiter(this, void 0, void 0, function* () {
            if (window.location.hostname === 'localhost') {
                return MOCKED_SITE_MEMBER;
            }
            const { body } = yield this.api.get(`/_api/apps/current-member/${process.env.WIX_APP_ID}`);
            return body;
        });
    }
    getAuthState() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const { account } = yield this.config.getSiteSettings();
            const body = yield this.getCurrentMember();
            return {
                token: body === null || body === void 0 ? void 0 : body.signedToken,
                userId: (_a = body === null || body === void 0 ? void 0 : body.member) === null || _a === void 0 ? void 0 : _a.id,
                provider: 'wix',
                account
            };
        });
    }
    getCheckoutInformation() {
        return __awaiter(this, void 0, void 0, function* () {
            return null; // FIXME
        });
    }
    registerWebsiteEvents() {
        const registerListener = () => {
            // @ts-ignore
            window.wixDevelopersAnalytics.register(process.env.WIX_APP_ID, (eventName, eventParams) => this.controlEvents(eventName, eventParams));
        };
        // @ts-ignore
        if (window.wixDevelopersAnalytics) {
            registerListener();
        }
        else {
            window.addEventListener('wixDevelopersAnalyticsReady', registerListener);
        }
    }
    controlEvents(name, params) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (name === 'PageView' && params.pageTypeIdentifier === 'Booking Form') {
                setTimeout(() => {
                    const checkoutValue = Number((document.querySelector('[data-hook="payment-total-price"] [data-hook="price-item-description"]') || {
                        textContent: '0'
                    }).textContent.replace(/[^0-9.-]+/g, ''));
                    if (checkoutValue)
                        this.session.set(sessionKeys.CHECKOUT_VALUE, checkoutValue, {
                            expires: Time.addDays(new Date(), 1)
                        });
                }, 1000);
            }
            if (name === 'InitiateCheckout') {
                const checkoutValue = Number(params.contents
                    .reduce((prev, actual) => prev + actual.price * actual.quantity, 0)
                    .toFixed(2)) || 0;
                if (checkoutValue)
                    this.session.set(sessionKeys.CHECKOUT_VALUE, checkoutValue, {
                        expires: Time.addDays(new Date(), 1)
                    });
            }
            if (name === 'Purchase') {
                const { account, provider } = this.config.getSiteSettings();
                const user = yield this.getCurrentMember();
                const authInit = yield this.getAuthState();
                yield this.backend.authenticate(authInit);
                const value = Math.trunc(params.revenue * 100);
                const shippingValue = Math.trunc((params.shipping || 0) * 100);
                yield this.checkout.handleCheckout({
                    account,
                    currency: params.currency,
                    value,
                    externalTransactionId: params.orderId || params.id,
                    externalCustomerId: (_a = user === null || user === void 0 ? void 0 : user.member) === null || _a === void 0 ? void 0 : _a.id,
                    externalCustomerEmail: params.buyerMail,
                    externalBuyerId: params.buyerId || params.visitorId,
                    transactionId: params.orderId || params.id,
                    coinsAmount: moneyToCoins(value - shippingValue, Number(get(AppState).business.rewardsSettings.coinRewardPercentage))
                }, provider);
            }
            if (name === 'CustomEvent' &&
                ['Log in Success', 'Sign up Success'].includes(params.eventAction)) {
                AppState.update(state => (Object.assign(Object.assign({}, state), { website: Object.assign(Object.assign({}, state.website), { authenticatedOnWebsite: true }) })));
            }
            if (name === 'CustomEvent' &&
                ['Log in Success', 'Sign up Success'].includes(params.eventAction) &&
                (this.session.get(WIX_CONNECTING_ACCOUNT) ||
                    !get(AppState).featureFlags.includes(flagKeys.SIGNUP_CONFIRMATION) ||
                    localStorage.getItem(sessionKeys.AUTH_SOFT_LOGIN))) {
                this.session.remove(WIX_CONNECTING_ACCOUNT);
                const AppStateData = get(AppState);
                const isCheckoutFlow = AppStateData.checkout && Object.keys(AppStateData.checkout).length > 0;
                const isFreeCoinsFlow = AppStateData.website.authFlow === 'free-coins';
                const isReferredFlow = AppStateData.website.authFlow === 'referred-redeem';
                const isFastRedemption = AppStateData.website.authFlow === 'fast-redemption';
                const popoverOpen = !(isCheckoutFlow ||
                    isFreeCoinsFlow ||
                    isReferredFlow ||
                    isFastRedemption);
                if (params.userId) {
                    let category = AppStateData.website.category;
                    if (isReferredFlow) {
                        category = 'referredCoin';
                    }
                    if (isFreeCoinsFlow) {
                        category = 'welcomeCoinAvailable';
                    }
                    if (localStorage.getItem(sessionKeys.AUTH_SOFT_LOGIN)) {
                        yield this.connect.loadAuthState();
                    }
                    AppState.update(state => (Object.assign(Object.assign({}, state), { website: Object.assign(Object.assign({}, state.website), { userId: params.userId, popoverOpen, category: popoverOpen ? '' : category, connectingAccount: true }) })));
                }
            }
            if (name === 'CustomEvent' &&
                ['Sign up Submit'].includes(params.eventAction)) {
                AppState.update(state => (Object.assign(Object.assign({}, state), { website: Object.assign(Object.assign({}, state.website), { requestEmailVerification: true }) })));
            }
        });
    }
    openLoginModal(data) {
        function openLogin() {
            const onSuccess = () => null;
            const onError = err => console.error(err);
            const loginOptions = Object.assign({ mode: 'signup', modal: true, onSuccess,
                onError }, data);
            // @ts-ignore
            window.wixEmbedsAPI.promptLogin(loginOptions);
        }
        // @ts-ignore
        if (window.wixEmbedsAPI) {
            openLogin();
        }
        else {
            window.addEventListener('wixEmbedsAPIReady', () => {
                openLogin();
            }, false);
        }
        this.session.set(WIX_CONNECTING_ACCOUNT, true);
    }
    isConnectingAccount() {
        return false;
    }
    isCurrentCartPage() {
        return (window.location.href.includes('/cart-page') ||
            window.location.href.includes('/bookings-checkout'));
    }
    isCurrentRemindCodePage() {
        const params = new URLSearchParams(location.search);
        return (window.location.href.includes('/checkout') &&
            !!params.get('checkoutId'));
    }
    isSoftLoginEnabled() {
        return __awaiter(this, void 0, void 0, function* () {
            const { items: featureFlags } = yield this.backend.getFeatureFlags();
            const flagEnabled = featureFlags.includes(flagKeys.NEW_SIGNUP_WIDGET_WIX_V2_MODAL);
            const { account } = yield this.getAuthState();
            const scopes = yield this.connect.getScopes(account);
            return ((scopes.includes('MEMBERS.MEMBER_CREATE') ||
                scopes.includes('SCOPE.DC-MEMBERS.MANAGE-MEMBERS')) &&
                flagEnabled);
        });
    }
    beforeAuthHook() {
        var _a;
        const menuToggle = document.getElementById('MENU_AS_CONTAINER_TOGGLE');
        if (menuToggle) {
            const isOpen = ((_a = menuToggle.attributes['aria-label']) === null || _a === void 0 ? void 0 : _a.value.indexOf('close')) > -1;
            if (isOpen) {
                menuToggle.click();
            }
        }
    }
    static togglePageMenu() {
        const menuToggle = document.getElementById('MENU_AS_CONTAINER_TOGGLE');
        if (menuToggle) {
            menuToggle.click();
            setTimeout(() => menuToggle.click(), 50);
        }
    }
}
Container.add(Wix);
